module.exports = __webpack_public_path__ + "img/736655_D9D8D5_2F281F_B1AEAB-256px.88ea024d.png";